import Swiper from 'swiper/bundle';

export default function initSliders() {
    new Sliders();
}

class Sliders {
    constructor() {
        this.init();
    }

    init() {
        this.initHero();
        this.initTestimonials();
    }

    initHero() {
        const swiperHero = document.querySelector('.swiper-hero');
        if (!swiperHero) return;

        new Swiper(swiperHero, {
            grabCursor: true,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-20%", 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
            navigation: {
                nextEl: ".hero .swiper-navigation .swiper-next",
                prevEl: ".hero .swiper-navigation .swiper-prev",
            },
        });
    }

    initTestimonials() {
        const swiperTestimonials = document.querySelector('.swiper-testimonials');
        if (!swiperTestimonials) return;

        new Swiper(swiperTestimonials, {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 90,
                },
            },
            navigation: {
                nextEl: ".testimonials .swiper-navigation .swiper-next",
                prevEl: ".testimonials .swiper-navigation .swiper-prev",
            },
        });
    }
}
